import styled from '@emotion/styled'

const StyledContainer = styled.div`
  display: flex;
  align-items: start;
`

export default StyledContainer
